import { sectors } from '@/mocks/formData';
import type { DashboardFilters, PeriodFilter } from '@/hooks/useDashboard';

interface FilterBarProps {
  filters: DashboardFilters;
  onFilterChange: (key: keyof DashboardFilters, value: string) => void;
}

const periodOptions: { value: PeriodFilter; label: string }[] = [
  { value: '7d', label: 'Últimos 7 dias' },
  { value: '30d', label: 'Últimos 30 dias' },
  { value: '90d', label: 'Últimos 90 dias' },
  { value: '12m', label: 'Últimos 12 meses' },
  { value: 'all', label: 'Todo período' },
];

const statusOptions = [
  { value: 'all', label: 'Todos os status' },
  { value: 'Pendente', label: 'Pendentes' },
  { value: 'Aprovado', label: 'Aprovados' },
  { value: 'Negado', label: 'Negados' },
];

export default function FilterBar({ filters, onFilterChange }: FilterBarProps) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mb-6">
      <div className="flex items-center gap-2">
        <i className="ri-filter-3-line text-portal-gray-400 text-sm"></i>
        <span className="text-xs font-medium text-portal-gray-500 whitespace-nowrap">Filtros:</span>
      </div>

      <select
        value={filters.period}
        onChange={(e) => onFilterChange('period', e.target.value)}
        className="text-sm px-3 py-2 rounded-lg border border-portal-gray-200 bg-white text-portal-gray-700 focus:outline-none focus:ring-2 focus:ring-portal-purple/20 focus:border-portal-purple cursor-pointer"
      >
        {periodOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>

      <select
        value={filters.setor}
        onChange={(e) => onFilterChange('setor', e.target.value)}
        className="text-sm px-3 py-2 rounded-lg border border-portal-gray-200 bg-white text-portal-gray-700 focus:outline-none focus:ring-2 focus:ring-portal-purple/20 focus:border-portal-purple cursor-pointer"
      >
        <option value="all">Todos os setores</option>
        {sectors.map((s) => (
          <option key={s} value={s}>{s}</option>
        ))}
      </select>

      <select
        value={filters.status}
        onChange={(e) => onFilterChange('status', e.target.value)}
        className="text-sm px-3 py-2 rounded-lg border border-portal-gray-200 bg-white text-portal-gray-700 focus:outline-none focus:ring-2 focus:ring-portal-purple/20 focus:border-portal-purple cursor-pointer"
      >
        {statusOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>

      <div className="flex items-center gap-2 ml-auto">
        <button
          type="button"
          className="flex items-center gap-1.5 px-3 py-2 text-xs font-medium text-portal-gray-600 bg-white border border-portal-gray-200 rounded-lg hover:bg-portal-gray-50 transition-colors cursor-pointer whitespace-nowrap"
          onClick={() => {
            // Mock export Excel
            alert('Exportação para Excel iniciada!');
          }}
        >
          <i className="ri-file-excel-2-line text-green-600 text-sm"></i>
          Excel
        </button>
      </div>
    </div>
  );
}